import * as React from 'react';
import {Component} from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import FooterTabMenu from './FooterTabMenu';
import {togglePinActiveScreens} from '../../../_shared/GWTBridge/invoke/footerPanel';
import {checkFile} from '../../../_shared/GWTBridge/invoke/footerPanel';
import {tabs} from '../consts';
import {FilePreview} from './FilePreview';
import {observable, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import {debounce} from '../../library/utils/debounce';
import {formsStore} from '../../Form/stores/FormsStore';
import {formsStore as newApiStore} from '../../../stores/Form/FormsStore';
import {Form as NewAPIForm} from '../../../stores/Form/Form';
import {Text} from '@priority-software/priority-style-react';
import newUITexts from '../../../features/Form/texts';
import {
    getCompanyBrushColorRGB,
    getCurProcDname,
    isCurrentEntADP,
    isCurrentEntBPM
} from '../../../_shared/GWTBridge/invoke/genPage';
import {BPMDialogModule} from '../../../features/Automations/modules/BPMRules/BPMDialog.module';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';

export interface footerFunctions {
    getLocalizedTxt: (text) => void;
    focus: () => void; // focus table field to previus input
    getLastUpdates: () => void;
}

export interface FooterPanelProps {
    currentFieldName: string;
    isRecentUpdatesOpen: boolean;
    isFilePreviewVisible: boolean;
    previewFileName: string;
    companyName: string;
    companyColor: string;
    currentRow: number;
    maxRows: number;
    sum: number;
    isPainted: () => boolean;
    tabs?: Array<any>;
    activeScreens?: Array<any>;
    lastUpdates?: Array<any>;
    recentItems?: Array<any>;
    getCaption: () => string;
    funcs: footerFunctions;
}

interface FooterPanelState {
    tabIndex: number;
}

interface TabProps {
    title: string;
    selected: boolean | string;
    image: JSX.Element;
    tabClick: () => void;
}

const Tab = (props: TabProps) => {
    const {title, tabClick, selected, image} = props;

    return (
        <div className={`menu-tab ${selected && 'selected'}`} onClick={tabClick}>
            {image} <span>{title}</span>
        </div>
    );
};

@observer
class FooterPanel extends Component<FooterPanelProps, FooterPanelState> {
    footerRef;
    @observable fileExists;

    constructor(props) {
        super(props);

        makeObservable(this);

        this.handleCloseTabsMenu = this.handleCloseTabsMenu.bind(this);
        this.setFooterRef = this.setFooterRef.bind(this);

        this.state = {tabIndex: null};
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // keep recent updates tab open after recent items update
        this.setState({
            tabIndex: nextProps.isRecentUpdatesOpen ? tabs.LAST_UPDATES : null
        });
        if (
            this.props.previewFileName !== nextProps.previewFileName ||
            this.props.isFilePreviewVisible !== nextProps.isFilePreviewVisible
        ) {
            nextProps.isFilePreviewVisible && this.getSearchResult(nextProps.previewFileName);
        }
    }

    checkPreviewFile = fileName => {
        this.fileExists = false;
        if (fileName && fileName.trim() !== '') {
            checkFile(fileName, response => {
                if (response.success && fileName === response.fileName) {
                    this.fileExists = true;
                }
            });
        }
    };

    getSearchResult = debounce(this.checkPreviewFile, 2000, false);

    setFooterRef(node) {
        this.footerRef = node;
    }

    handleCloseTabsMenu() {
        this.setState({
            tabIndex: null
        });

        this.props.funcs && this.props.funcs.focus && this.props.funcs.focus();
    }

    handleTabClick(index) {
        let newIndex = null;
        if (this.state.tabIndex !== index) {
            newIndex = index;
        }

        if (newIndex === tabs.ACTIVE_SCREENS && localStorage.getItem('isActiveScreensPinned')) {
            togglePinActiveScreens(false);
            return;
        }

        if (newIndex === null) {
            this.handleCloseTabsMenu();
        }

        if (newIndex === tabs.LAST_UPDATES && this.props.funcs && this.props.funcs.getLastUpdates) {
            this.props.funcs.getLastUpdates();
        } else {
            this.setState({
                tabIndex: newIndex
            });
        }
    }

    renderTabs() {
        const {tabIndex} = this.state;
        const {tabs, activeScreens} = this.props;
        const images = [
            <Icon
                key={PriorityIcon.newClock}
                icon={PriorityIcon.newClock}
                componentClasses="footer-panel-tab-icon"
            />,
            <Icon
                key={PriorityIcon.renew}
                icon={PriorityIcon.renew}
                componentClasses="footer-panel-tab-icon"
            />,
            <Icon
                key={PriorityIcon.windows}
                icon={PriorityIcon.windows}
                componentClasses="footer-panel-tab-icon "
                counterValue={activeScreens.length}
            />
        ];

        return tabs.map((tab, index) => {
            return (
                <Tab
                    key={index}
                    tabClick={() => {
                        this.handleTabClick(index);
                    }}
                    title={tab.title}
                    image={images[index]}
                    selected={index === tabIndex ? 'selected' : false}
                />
            );
        });
    }

    newAPICurrentRow = (newAPIActiveForm: NewAPIForm) => {
        return newAPIActiveForm.paginationOffset + newAPIActiveForm.currentRow + 1;
    };

    render() {
        const {
            companyName,
            companyColor,
            getCaption,
            previewFileName,
            isFilePreviewVisible,
            isPainted
        } = this.props;

        let {currentFieldName, currentRow, maxRows, sum} = this.props;

        const {currentForm} = formsStore;

        if (formsStore.isReactView && currentForm) {
            const {headerTitle, row} = currentForm.currentCell;
            currentFieldName = headerTitle;
            currentRow = row + 1;
            maxRows = currentForm.rows.length;
            sum = currentForm.currentColSum;
        } else if (newApiStore?.currentScreen) {
            const focusedForm = newApiStore.currentScreen.getActiveForm();
            if (focusedForm && !focusedForm.searchModeLevel && focusedForm.records?.length) {
                currentFieldName = focusedForm.currentColumn?.Title;
                currentRow = focusedForm.currentRow + 1;
                maxRows =
                    currentRow === focusedForm.records?.length
                        ? focusedForm.records?.length
                        : focusedForm.records?.length - 1;
            }
        }

        const rowPosition = `${Number(currentRow).toLocaleString()} / ${Number(
            maxRows
        ).toLocaleString()}`;
        const caption = getCaption && getCaption();

        const newAPIActiveForm = newApiStore?.currentScreen?.getActiveForm();
        return (
            <div className="footer-wrapper" style={{zIndex: getTopDialogZindex()}}>
                <FooterTabMenu
                    tabIndex={this.state.tabIndex}
                    closeMenu={this.handleCloseTabsMenu}
                    footerRef={this.footerRef}
                    {...this.props}
                />

                {isCurrentEntBPM() && <BPMDialogModule />}
                <footer ref={this.setFooterRef} className="footer-menu">
                    <section className="left-panel">
                        {(companyName || isCurrentEntADP()) && (
                            <div className="left-panel-item">
                                <div className="company-panel">
                                    {caption && caption !== '' && (
                                        <div className="caption-container">{caption}</div>
                                    )}
                                    <div
                                        className="company-color"
                                        style={{
                                            backgroundColor:
                                                companyColor ||
                                                (isCurrentEntADP() && getCompanyBrushColorRGB())
                                        }}
                                    />
                                    <div className="company-name">
                                        {companyName || getCurProcDname()}
                                    </div>
                                </div>
                            </div>
                        )}
                        {!isCurrentEntADP() && currentFieldName && currentFieldName !== '' && (
                            <React.Fragment>
                                <div className="left-panel-item">
                                    {newAPIActiveForm ? (
                                        <Text
                                            skin="paragraph-2"
                                            fontWeight="normal"
                                            tag="div"
                                            textColor="white"
                                            componentClasses="info-item-results"
                                        >
                                            {newUITexts.record_label}{' '}
                                            {this.newAPICurrentRow(newAPIActiveForm)}
                                        </Text>
                                    ) : (
                                        <div className="info-item-results">
                                            <span className="value">{rowPosition}</span>
                                            <span>{getLocalizedText(texts.results)}</span>
                                        </div>
                                    )}
                                </div>

                                <div className="left-panel-item">
                                    <div className="info-field">
                                        <span className="label">
                                            {getLocalizedText(texts.field)}
                                        </span>
                                        <span className="value">{currentFieldName}</span>
                                    </div>
                                </div>

                                {isPainted && !isPainted() && sum && (
                                    <div className="left-panel-item">
                                        <div className="info-field info-panel">
                                            <span className="label">
                                                {getLocalizedText(texts.count)}
                                            </span>
                                            <span className="value">{currentRow}</span>
                                            <div className="seperator" />
                                            <span className="label">
                                                {getLocalizedText(texts.subtotal)}
                                            </span>
                                            <span className="value">{sum}</span>
                                        </div>
                                    </div>
                                )}

                                {isFilePreviewVisible && (!previewFileName || this.fileExists) && (
                                    <div className="left-panel-item">
                                        <FilePreview previewFileName={previewFileName} />
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </section>
                    <div className="pop-menu-tabs">{this.renderTabs()}</div>
                </footer>
            </div>
        );
    }
}

export default FooterPanel;
